module.exports = __webpack_public_path__ + "img/switzerland-tuberculosis-female.99502201.png";